export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9245.4573411d.jpg";